import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
function createRoundedRectPath(x, y, width, height, radius) {
    return (
    // Move to position, offset by radius in x direction
    `M ${x + radius}, ${y}` +
        // Draw a horizontal line to the top right curve start
        `h ${width - 2 * radius}` +
        // Draw the top right corner curve
        `a ${radius} ${radius} 0 0 1 ${radius} ${radius}` +
        // Draw a vertical line to the bottom right corner
        `v ${height - 2 * radius}` +
        // // Draw the bottom right corner curve
        `a ${radius},${radius} 0 0 1 ${-radius},${radius}` +
        // // Draw a horizontal line to the bottom left corner
        `h ${2 * radius - width}` +
        // // Draw the bottom left corner
        `a ${-radius},${-radius} 0 0 1 ${-radius},${-radius}` +
        // // Draw a vertical line to the top left corner
        `v ${2 * radius - height}` +
        // // Draw the top left corner
        `a ${radius},${-radius} 0 0 1 ${radius},${-radius}` +
        // Close the shape
        'z');
}
export function DashedSector({ cx, cy, rx, ry, ...rest }) {
    let startRad, endRad;
    let pathProps;
    if ('startRad' in rest) {
        ({ startRad, endRad, ...pathProps } = rest);
    }
    else {
        let startDeg, endDeg;
        ({ startDeg, endDeg, ...pathProps } = rest);
        startRad = (startDeg / 180) * Math.PI;
        endRad = (endDeg / 180) * Math.PI;
    }
    const result = [];
    for (let rad = startRad; rad <= endRad; rad = rad + 0.15) {
        const x = Math.cos(rad) * rx + cx;
        const y = Math.sin(rad) * ry + cy;
        const deg = (rad * 180) / Math.PI;
        result.push(_createElement("path", { ...pathProps, d: createRoundedRectPath(x, y, 5, 1, 0.5), transform: `rotate(${deg}, ${x}, ${y})`, key: Math.random().toString() }));
    }
    return _jsx(_Fragment, { children: result.map((path) => path) });
}
